import { countryActions } from "./country-slice";
import { uiActions } from "../ui-slice";

export const GetCountries = (email) => {
  return async (dispatch, showNotification) => {
    if (showNotification !== undefined && showNotification === true) {
      dispatch(
        uiActions.showNotification({
          status: "pending",
          title: "Cargando información",
          message: "Se esta solicitando la información al servidor.",
        })
      );
    }
    const GetCountrysInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/Country/getall`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener la información solicitada");
      }
      const data = await response.json();
      return data;
    };

    try {
      const response = await GetCountrysInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          countryActions.setCountries({
            countries: response.data.map((country) => {
              return {
                ...country,
                status: country.status === true ? "Activo" : "Inactivo",
              };
            }),
          })
        );
        if (showNotification !== undefined && showNotification === true) {
          dispatch(
            uiActions.showNotification({
              status: "success",
              title: "Datos Cargados",
              message: response.result.message,
            })
          );
        }
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          countryActions.setCountries({
            countries: [],
          })
        );
        if (showNotification !== undefined && showNotification === true) {
          dispatch(
            uiActions.showNotification({
              status: "warning",
              title: "Advertencia",
              message: response.result.message,
            })
          );
        }
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener la información solicitada",
        })
      );
    }
  };
};
export const GetCountry = (id, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Solicitando país",
        message: "Solicitando país al servidor.",
      })
    );
    const getCountryInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/Country/getById`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener el país");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getCountryInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          countryActions.setCountry({
            country: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Datos Cargados",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          countryActions.setCountry({
            country: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener el país",
        })
      );
    }
  };
};
export const UpdateCountry = (country, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Actualizando país",
        message: "Solicitando Actualización del país al servidor.",
      })
    );
    const updateCountryInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/Country/update`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Id: country.id,
            Name: country.name,
            Code: country.code,
            status: country.status,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo actualizar el país");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await updateCountryInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          countryActions.setCountry({
            country: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "país Actualizado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          countryActions.setCountry({
            country: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo actualizar el país",
        })
      );
    }
  };
};
export const CreateCountry = (country, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Creando país",
        message: "Solicitando Creación del país al servidor.",
      })
    );
    const createCountryInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/Country/create`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Name: country.name,
            Code: country.code,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo crear el país");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await createCountryInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          countryActions.setCountry({
            country: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "país Creado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          countryActions.setCountry({
            country: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo crear el país",
        })
      );
    }
  };
};
export const ActiveCountry = (id, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Activando país",
        message: "Solicitando activación del país al servidor.",
      })
    );
    const activeCountryInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/Country/active`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo activar el país");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await activeCountryInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          countryActions.setCountry({
            country: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "país Activado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          countryActions.setCountry({
            country: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo activar el país",
        })
      );
    }
  };
};
export const InactiveCountry = (id, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Inactivando país",
        message: "Solicitando activación del país al servidor.",
      })
    );
    const inactiveCountryInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/Country/inactive`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo inactivar el país");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await inactiveCountryInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          countryActions.setCountry({
            country: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "país Inactivado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          countryActions.setCountry({
            country: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo inactivar el país",
        })
      );
    }
  };
};
